// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkWithCarlaiRouteImport } from './routes/work-with-carlai'
import { Route as VillageRouteImport } from './routes/village'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TrustOperatingSystemRouteImport } from './routes/trust-operating-system'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TabriRouteImport } from './routes/tabri'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PodcastRouteImport } from './routes/podcast'
import { Route as MetaPreviewRouteImport } from './routes/meta-preview'
import { Route as ForOrganizationsRouteImport } from './routes/for-organizations'
import { Route as ForAgenciesRouteImport } from './routes/for-agencies'
import { Route as ConferenceRouteImport } from './routes/conference'
import { Route as CeoSuiteRouteImport } from './routes/ceo-suite'
import { Route as CeoPractitionerNetworkRouteImport } from './routes/ceo-practitioner-network'
import { Route as BookSpeakingRouteImport } from './routes/book-speaking'
import { Route as BookCarlaiRouteImport } from './routes/book-carlai'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'

const WorkWithCarlaiRoute = WorkWithCarlaiRouteImport.update({
            id: '/work-with-carlai',path: '/work-with-carlai',getParentRoute: () => rootRouteImport
          })
const VillageRoute = VillageRouteImport.update({
            id: '/village',path: '/village',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TrustOperatingSystemRoute = TrustOperatingSystemRouteImport.update({
            id: '/trust-operating-system',path: '/trust-operating-system',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TabriRoute = TabriRouteImport.update({
            id: '/tabri',path: '/tabri',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PodcastRoute = PodcastRouteImport.update({
            id: '/podcast',path: '/podcast',getParentRoute: () => rootRouteImport
          })
const MetaPreviewRoute = MetaPreviewRouteImport.update({
            id: '/meta-preview',path: '/meta-preview',getParentRoute: () => rootRouteImport
          })
const ForOrganizationsRoute = ForOrganizationsRouteImport.update({
            id: '/for-organizations',path: '/for-organizations',getParentRoute: () => rootRouteImport
          })
const ForAgenciesRoute = ForAgenciesRouteImport.update({
            id: '/for-agencies',path: '/for-agencies',getParentRoute: () => rootRouteImport
          })
const ConferenceRoute = ConferenceRouteImport.update({
            id: '/conference',path: '/conference',getParentRoute: () => rootRouteImport
          })
const CeoSuiteRoute = CeoSuiteRouteImport.update({
            id: '/ceo-suite',path: '/ceo-suite',getParentRoute: () => rootRouteImport
          })
const CeoPractitionerNetworkRoute = CeoPractitionerNetworkRouteImport.update({
            id: '/ceo-practitioner-network',path: '/ceo-practitioner-network',getParentRoute: () => rootRouteImport
          })
const BookSpeakingRoute = BookSpeakingRouteImport.update({
            id: '/book-speaking',path: '/book-speaking',getParentRoute: () => rootRouteImport
          })
const BookCarlaiRoute = BookCarlaiRouteImport.update({
            id: '/book-carlai',path: '/book-carlai',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AccessibilityRoute: AccessibilityRoute,AuthRoute: AuthRoute,BookCarlaiRoute: BookCarlaiRoute,BookSpeakingRoute: BookSpeakingRoute,CeoPractitionerNetworkRoute: CeoPractitionerNetworkRoute,CeoSuiteRoute: CeoSuiteRoute,ConferenceRoute: ConferenceRoute,ForAgenciesRoute: ForAgenciesRoute,ForOrganizationsRoute: ForOrganizationsRoute,MetaPreviewRoute: MetaPreviewRoute,PodcastRoute: PodcastRoute,PrivacyRoute: PrivacyRoute,TabriRoute: TabriRoute,TermsRoute: TermsRoute,TrustOperatingSystemRoute: TrustOperatingSystemRoute,UnsubscribeRoute: UnsubscribeRoute,VillageRoute: VillageRoute,WorkWithCarlaiRoute: WorkWithCarlaiRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)